// src/components/registration/steps/userGroupSteps/UserGroupsStep1Intro.jsx

import React from "react";
import PropTypes from "prop-types";
import MultiStyleButton from "../../../../systemUtils/MultiStyleButton";

const UserGroupsStep1Intro = ({ setCardStep }) => (
  <>
    <h1 className="card-title step1-title">Add User Groups</h1>
    <p className="card-subtitle step1-subtitle">
      Configure your organization's structure by creating User Groups, defining
      Roles, and assigning Users.
    </p>
    <div className="continue-button-container">
      <MultiStyleButton
        label="Continue"
        buttonType="approve"
        onClick={() => setCardStep(2)}
      />
    </div>
  </>
);

UserGroupsStep1Intro.propTypes = {
  setCardStep: PropTypes.func.isRequired,
};

export default UserGroupsStep1Intro;
